


















import Vue from "vue";
import { createNamespacedHelpers } from "vuex";
import clientCategoryStoreModule from "@/store/modules/clientCategories";
import { Business, ClientCategory, Role } from "@/types";

const { mapActions: ClientCategoryActions, mapGetters: ClientCategoryGetters } =
  createNamespacedHelpers("CLIENTCATEGORY");

interface ClientCategoryPage {
  docs: ClientCategory[];
}

interface Props {
  label?: string;
  rules?: ((v: string[]) => boolean | string)[];
}

export default Vue.extend<
  { selectedCategories: string[] },
  {
    fetchCategories(): void;
    emitSelected(): void;
    fetchClientCategoryList(query: string): Promise<void>;
  },
  {
    clientCategoryPage: ClientCategoryPage;
    role: Role;
  },
  Props
>({
  name: "ClientCategoryDropdown",
  props: {
    label: {
      type: String,
      default: "Select Categories",
    },
    rules: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    selectedCategories: [] as string[],
  }),
  computed: {
    ...ClientCategoryGetters(["clientCategoryPage"]),
    role(): Role {
      return this.$store.getters.role;
    },
  },
  methods: {
    ...ClientCategoryActions(["fetchClientCategoryList"]),
    fetchCategories() {
      if (this.role) {
        const params = `?businessId=${(this.role.business as Business)?._id}`;
        this.fetchClientCategoryList(params);
      }
    },
    emitSelected() {
      const selectedCategoryObjects = this.clientCategoryPage.docs.filter(
        (category) => this.selectedCategories.includes(category._id)
      );
      this.$emit("selected", selectedCategoryObjects);
      this.$emit("input", this.selectedCategories);
    },
  },
  created() {
    this.fetchCategories();
  },
  beforeCreate() {
    if (!this.$store.hasModule("CLIENTCATEGORY")) {
      this.$store.registerModule("CLIENTCATEGORY", clientCategoryStoreModule);
    }
  },
  beforeDestroy() {
    this.$store.unregisterModule("CLIENTCATEGORY");
  },
});
